import MarketingPage from "../components/MarketingPage";
import { APP_STORE_URL, ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema } from "../lib/seo";

export default function AiStylist() {
  return (
    <MarketingPage
      seo={{
        title: "AI Personal Stylist | Personalized Outfit Ideas | C-STYL",
        description: "C-STYL is your AI personal stylist. Get personalized, weather-aware outfit ideas built from the clothes you already own, tuned to your occasion, style and feedback.",
        path: "/ai-stylist",
        testid: "ai-stylist-page",
        jsonLd: [ORG_SCHEMA, SOFTWARE_APP_SCHEMA, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "AI Stylist", path: "/ai-stylist" }])],
      }}
      crumb="AI Stylist"
      eyebrow="Personal AI stylist"
      h1="Your Personal AI Stylist"
      lead="Not sure what to wear today? C-STYL builds a complete outfit using the clothes you already own."
      sections={[
        { h2: "Daily recommendations", p: ["Open the Today tab and C-STYL assembles a complete, head-to-toe outfit from your closet, with a short note on why it works."] },
        { h2: "What recommendations can consider", bullets: ["The weather where you are", "The occasion — casual, work, business casual, date night", "Your personal style preferences", "How well pieces go together", "Colour", "Rotation, so you don't repeat the same looks", "Your previous feedback and recently worn items"] },
        { h2: "Styled from your own wardrobe", p: ["C-STYL never invents clothes. Every suggestion is a real combination of pieces you own — the AI only writes the explanation."] },
        { h2: "Make it yours with Mix & Match", p: ["Love most of a look? Swap any single piece by category until it feels right, then try it on and save it."] },
      ]}
      cta={{ label: "Download C-STYL", href: APP_STORE_URL, external: true }}
    />
  );
}
